import { FC } from 'react';
import styles from './styles.module.scss';
import { Box } from '@mui/material';
import { BaseFeedLayout, Container, LazyLottie, VideoAnimation } from '@/components';
import Image, { StaticImageData } from 'next/image';

export enum FeedSectionItemType {
  Image = 'image',
  Animation = 'animation',
  Video = 'video',
}

type FeedSectionItemImage = FeedSectionItem & {
  imageSrc: StaticImageData;
  type: FeedSectionItemType.Image;
};

type FeedSectionItem = {
  titleKey: string;
  textKey: string;
};

type FeedSectionItemAnimation = FeedSectionItem & {
  animationSrc: string;
  previewSrc: string | StaticImageData;
  type: FeedSectionItemType.Animation;
};

type FeedSectionItemVideo = FeedSectionItem & {
  animationSrc: string;
  previewSrc: string | StaticImageData;
  type: FeedSectionItemType.Video;
};

type FeedSectionProps = {
  ns: string;
  items: FeedSectionItemImage[] | FeedSectionItemAnimation[] | FeedSectionItemVideo[];
};

export const FeedSection: FC<FeedSectionProps> = ({ ns, items }) => {
  return (
    <Box className={styles.section}>
      <Container>
        {items.map((item, index) => (
          <BaseFeedLayout
            key={item.titleKey}
            className={styles.row}
            titleKey={item.titleKey}
            textKey={item.textKey}
            variant={index % 2 === 0 ? 'default' : 'reverse'}
            ns={ns}
            image={
              <Box className={styles.itemImage}>
                {item.type === FeedSectionItemType.Video && (
                  <VideoAnimation src={item.animationSrc} poster={item.previewSrc} />
                )}
                {item.type === FeedSectionItemType.Image && (
                  <Image alt="" src={item.imageSrc} />
                )}
                {item.type === FeedSectionItemType.Animation && (
                  <LazyLottie
                    dataSrc={item.animationSrc}
                    previewSrc={item.previewSrc}
                    previewProps={{ alt: '', loading: 'lazy' }}
                  />
                )}
              </Box>
            }
          />
        ))}
      </Container>
    </Box>
  );
};
